"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import Image from 'next/image';
export default function Navbar() {
  const $ = _c(16);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 20);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      href: "#features",
      label: "Features"
    }, {
      href: "#courses",
      label: "Courses"
    }, {
      href: "#how-it-works",
      label: "How It Works"
    }, {
      href: "#for-companies",
      label: "For Companies"
    }, {
      href: "#feedbacks",
      label: "Feedbacks"
    }, {
      href: "#about",
      label: "About Us"
    }];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const navLinks = t2;
  const t3 = isScrolled ? "bg-white/95 backdrop-blur-md shadow-lg" : "bg-white/80 backdrop-blur-md";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("fixed top-0 left-0 right-0 z-50 transition-all duration-300", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="/" className="flex items-center group"><div className="relative w-36 h-12 group-hover:scale-105 transition-transform"><Image src="/logo.svg" alt="Learn 2 Link" fill={true} className="object-contain" /></div></Link>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="hidden md:flex items-center gap-8">{navLinks.map(_temp)}</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link href="/auth/login"><Button variant="ghost" size="default" className="text-gray-700 hover:bg-gray-100">Sign In</Button></Link>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="hidden md:flex items-center gap-4">{t7}<Link href="/auth/signup"><Button variant="default" size="default" className="bg-[#6059f7] hover:bg-[#6059f7]/90">Get Started</Button></Link></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] !== isMobileMenuOpen) {
    t9 = <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><div className="flex items-center justify-between h-20">{t5}{t6}{t8}<button className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>{isMobileMenuOpen ? <X className="w-6 h-6 text-gray-700" /> : <Menu className="w-6 h-6 text-gray-700" />}</button></div></div>;
    t10 = isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-200 shadow-xl"><div className="px-4 py-6 space-y-4">{navLinks.map(link_0 => <a key={link_0.href} href={link_0.href} className="block py-2 text-gray-700 font-medium hover:text-[#6059f7] transition-colors" onClick={() => setIsMobileMenuOpen(false)}>{link_0.label}</a>)}<div className="pt-4 space-y-3 border-t border-gray-200"><Link href="/auth/login" className="block"><Button variant="ghost" size="default" className="w-full hover:bg-gray-100">Sign In</Button></Link><Link href="/auth/signup" className="block"><Button variant="default" size="default" className="w-full bg-[#6059f7] hover:bg-[#6059f7]/90">Get Started</Button></Link></div></div></div>;
    $[9] = isMobileMenuOpen;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t4 || $[14] !== t9) {
    t11 = <nav className={t4}>{t9}{t10}</nav>;
    $[12] = t10;
    $[13] = t4;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}
function _temp(link) {
  return <a key={link.href} href={link.href} className="font-medium text-gray-700 hover:text-[#6059f7] transition-colors">{link.label}</a>;
}